import { BaseLayoutFactory } from "../global/base-layout-factory";
import { GovernmentProjectsProvider } from "./context/government-projects-context";
import { GovernmentProjectsComponent } from "./government-projects-component";

export function GovernmentProjectsFactory() {
    return (
        <BaseLayoutFactory>
            <GovernmentProjectsProvider>
                <GovernmentProjectsComponent />
            </GovernmentProjectsProvider>
        </BaseLayoutFactory>
    );
}
